module.exports = __webpack_public_path__ + "img/mli.e6f097f9.svg";